import Breadcrumbs from "components/Common/Breadcrumb"
import Notifications from "components/Notifications"
import DeleteConfirmationModel from "components/delete-confirmation-model"
import { getCode, userModuleData } from 'helpers/basic_helper'
import { MASTER_URL } from "helpers/url_helper"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { useDispatch } from 'react-redux'
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap"
import { addRecord, getAllRows } from 'store/actions'
import { GetHelper } from '../CallHelper'
import FormComponent from "../FormComponent"
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";

const Master_URL = `${MASTER_URL}${process.env.REACT_APP_CLIENT_CATEGORY}`

const isType = 'Client Priority'
const ClientPriority = props => {
    const dispatch = useDispatch()
    const [open, isOpen] = useState(false)
    const [editableObj, setEditableObj] = useState({})
    const [dataRows, setDataRows] = useState([])
    const [isEdit, setIsEdit] = useState(false)
    const [isDeleteModel, setIsDeleteModel] = useState(false)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })

    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);

    const getData = async (ID = false) => {
        if (!ID) setIsLoading(true)
        const res = await GetHelper(`${process.env.REACT_APP_CLIENT_CATEGORY}?page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`, ID)
        if (ID) {
            setEditableObj(...res)
            isOpen(true)
            setIsEdit(false)
        } else {
            setIsLoading(false)
            setDataRows(res)
        }
    }

    /**
     * Submit or Update data Api Call
     * @param {Form Data} data 
     * @method {post} POST 
     */
    const submitForm = (data) => {
        const checkCode = dataRows?.rows?.filter(v => (v.code).toUpperCase() == (data.target.code.value).toUpperCase())
        if (data?.target?.id?.value == '' && checkCode.length > 0) {
            Notifications('please enter unique code.!', 'error')
            return;
        }

        const Obj = {
            "title": data.target.title.value,
            "code": data.target.code.value
        }
        dispatch(addRecord({ isType: isType, Obj: Obj, url: Master_URL + `${data?.target?.id?.value ? '&q=' + data?.target?.id?.value : ''}`, id: data?.target?.id?.value }, props.history, () => {
            getData()
            setIsEdit(false)
            isOpen(false)
            Notifications('You have successfully added a Client Priority.!')
        }))
    }

    /**
     * Get Single row using url params ?q=?
     * @param {Row_id} q 
     * @method {get} GET 
     */
    const handleEdit = q => {
        if (q > 0) {
            setIsEdit(q)
            dispatch(getAllRows({ url: `${Master_URL}&q=${q}`, isSingle: true }, props.history, (data) => {
                setEditableObj(data)
                isOpen(true)
            }))
        }
    }

    /**
     * Chnage Row Status By ID and condition Based Status passing,
     * @param {row_id} q 
     * @param {row Status} status 
     * @method {del} DELETE 
     */
    const handleRemove = (q, status, code) => {
        if (q != '') {
            setIsDeleteModel({ url: process.env.REACT_APP_CLIENT_CATEGORY, q, status, code })
        }
    }

    const hideModel = () => {
        setIsDeleteModel(false)
        getData()
    }

    /**
     * DataTable with Condition based row formating
     */
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        }, {
            dataField: 'title',
            text: 'Priority'
        }, {
            dataField: 'code',
            text: 'Code'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="btn btn-outline-secondary btn-sm edit" onClick={() => handleEdit(row.id)} title="Track or status" ><i className={`fas fa-pencil-alt`} /></Link>
                <Link to="#" className="ms-1 btn btn-outline-danger btn-sm edit" onClick={() => handleRemove(row.id, row.status, row.code)} title="Track or status" ><i className={`fas fa-trash-alt`} /></Link>
            </>
        }
    ];

    /**
     * HTML Form Columns 
     */
    let htmlFormFields = [
        {
            name: "id",
            required: false,
            type: 'hidden',
            value: editableObj ? editableObj.id : '',
            col: 12
        }, {
            name: "title",
            label: "Priority",
            placeholder: "Please Enter Client Priority",
            required: true,
            type: 'text',
            value: editableObj ? editableObj.title : '',
            col: 12
        }, {
            name: "code",
            label: "Code",
            placeholder: "Please Enter Client Priority Code",
            required: true,
            type: 'text',
            disable: editableObj?.code ? true : false,
            value: editableObj ? editableObj.code : getCode("client_category", dataRows?.total_rows),
            col: 12
        }
    ]

    useEffect(async () => {
        const data = await userModuleData('masters', 'locations')
        setIsActions(data)
        if (data && (data?.edit || data?.delete)) {
            setIsActionColumn(true)
        }
    }, [])


    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags><title>Dashboard | {isType}</title></MetaTags>
                <Container fluid>
                    <Breadcrumbs pageTitle="Masters" title="Masters" breadcrumbItem={["Client", "Priority"]} />

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables
                                        isSearch={true}
                                        columns={datatableData}
                                        showTableOnly={true}
                                        rowsLength={dataRows?.total_rows || 0}
                                        rows={dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={() => {
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}
                                        title="All Priority"
                                        loading={isLoading}
                                        isAdd={true}
                                        isTableHead={true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Datatable */}
            {
                open &&
                <FormComponent
                    title={`${editableObj ? 'Edit' : 'Add'} Priority`}
                    Position={"right"}
                    isOpen={open}
                    fileds={htmlFormFields}
                    loading={isLoading}
                    editableObj={editableObj}
                    onDrawerClose={() => {
                        setIsEdit(false)
                        setEditableObj(null)
                        isOpen(!open)
                    }}
                    submitForm={submitForm}
                />
            }
            {/* End Datatable */}
            {isDeleteModel && <DeleteConfirmationModel isOpen={true} changeState={hideModel} code={isDeleteModel} />}
        </React.Fragment>
    )
}

export default ClientPriority
